export interface IHarcodedLabel {
    key: string;
    value: string;
}

export class HarcodedLabel implements IHarcodedLabel {
    constructor(
        public key: string,
        public value: string
    ) { }
}
